import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'

import './HomeFacilities.css'

const FACILITIES_URL = '/facilities'

function HomeFacilities() {
    let navigate = useNavigate()

    const [facilities, setFacilities] = useState([])
    const [sortedFacilities, setSortedFacilities] = useState([])

    useEffect(() => {
        async function getFacilities() {
            try {
                const response = await axios.get(process.env.REACT_APP_DEPT_API + FACILITIES_URL);
                setFacilities(response.data);
            } catch (error) {
                console.error(error);
            }
        }
        getFacilities()
    }, [])

    useEffect(() => {
        let sorted = facilities && facilities.sort((a, b) => a.order_no < b.order_no ? -1 : 1)
        setSortedFacilities(sorted.splice(0, 3))
    }, [facilities])

    return (
        <div className='homeFacilities'>
            <div className='home_hod_section__container'>
                <div className='white_section__header_facility'>Facilities</div>
                <div className='home_facility_info'>
                    {sortedFacilities && sortedFacilities.map((fac, id) => (
                        <div className={id % 2 === 0 ? 'home_facility_card' : 'home_facility_card reverse'} key={fac._id}>
                            <div className='home_facility_content' data-aos="fade-right">
                                <h1>{fac.title}</h1>
                                <p>{fac.description}</p>
                            </div>
                            <div className='home_facility_image' data-aos="fade-left">
                                <img className='home_facility__img' src={fac.image && fac.image.url} alt='' />
                            </div>
                        </div>
                    ))}

                    <button className='facility_btn' onClick={() => navigate('facilities')}>View All Facilities</button>
                </div>
            </div>

        </div>
    )
}

export default HomeFacilities